/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import { Unit, checkIfValueIsValid, formatValue } from '../common';
/** @format */

// eslint-disable-next-line no-unused-vars

const ParticipationAndRepairFactsRow = ({ facts, objectText }) => {
  const krFields = [
    'repairFund',
    'monthlyFee',
    'indirectNetDebt',
    'participationOffAnnualFee',
    'participationInAssociation'
  ];

  if (checkIfValueIsValid(facts?.value)) {
    const factKey = FACTS_FIELD_KEYS.PARTICIPATION_REPAIR_FUND;
    const factFieldName = facts?.factFieldName;
    return (
      <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
        <div className='object-listing-accordian-list-left'>
          {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
            objectText?.[factKey]?.[factFieldName]?.label ||
            facts?.factFieldName}
        </div>
        <div className='object-listing-accordian-list-right'>
          {formatValue({ facts, krFields })}{' '}
          <Unit facts={facts} krFields={krFields} />
        </div>
      </div>
    );
  }

  return <></>;
};

export const getParticipationAndRepairFundData = (props) => {
  const { dataSet } = props;
  const fundsData = dataSet[FACTS_FIELD_KEYS.PARTICIPATION_REPAIR_FUND] || {};

  fundsData.monthlyFee = dataSet?.baseInfo?.monthlyFee;

  const response = {
    body: []
  };

  if (fundsData && Object.keys(fundsData).length > 0) {
    Object.keys(fundsData).forEach((factRecordKey) => {
      response.body.push(
        <ParticipationAndRepairFactsRow
          {...props}
          facts={{
            factFieldName: factRecordKey,
            value: fundsData[factRecordKey]
          }}
        />
      );
    });
  }

  return response;
};
